import React, { useState, useEffect } from 'react';
import EditableField from './EditableField';
import { apiRequest } from '../PromptManagerTemplate/services/promptManagerService';
import { API_ENDPOINTS, HTTP_METHODS } from '../../constants/appConstants';
import { useAuth } from '../../contexts/AuthContext';

/**
 * EditableComponent
 * Main component for managing editable workflow fields
 */
const EditableComponent = ({
  workflowName,
  setWorkflowName,
  workflowDescription,
  setWorkflowDescription,
  handleStatusChange,
  filters,
  handleCategoryChange,
}) => {
  const { token, handleLogout } = useAuth();
  const [categoryOptions, setCategoryOptions] = useState([
    { value: '', label: 'Select Category' },
  ]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await apiRequest(
          API_ENDPOINTS.CATEGORY_LIST,
          HTTP_METHODS.POST,
          { deletedAt: 'null' },
          token,
          handleLogout
        );

        if (response?.data?.length) {
          const mappedOptions = response.data.map((category) => ({
            value: toSlug(category.category_name),
            label: category.category_name,
          }));

          setCategoryOptions([
            { value: '', label: 'Select Category' },
            ...mappedOptions,
          ]);
        }
      } catch (error) {
        console.error('Failed to fetch categories:', error);
      }
    };

    fetchCategories();
  }, [token, handleLogout]);

    const toSlug = (label) => {
    return label
      .toLowerCase() // make lowercase
      .replace(/\s+/g, '-') // replace spaces with dashes
      .replace(/[^\w-]+/g, ''); // remove non-word characters (optional)
  };
  
  return (
    <div style={{ display: 'block', gap: '10px', marginTop: '15px' }}>
      <h2
        style={{
          font: 'normal normal 600 18px/22px Inter',
          color: '#222124',
          marginBottom: '10px',
        }}
      >
        <EditableField
          value={workflowName}
          onChange={setWorkflowName}
          placeholder="Workflow title"
          maxLength={50}
        />
      </h2>

      <p style={{ color: '#808081', marginBottom: '10px' }}>
        <EditableField
          value={workflowDescription}
          onChange={setWorkflowDescription}
          placeholder="Description"
          maxLength={100}
        />
      </p>

      <div style={{ display: 'block' }}>
        {/* Hidden status selector (optional) */}
        <div style={{ display: 'none' }}>
          <EditableField
            value={filters.status}
            onChange={handleStatusChange}
            options={[
              { value: 'ACTIVE', label: 'Active' },
              { value: 'INACTIVE', label: 'Inactive' },
            ]}
          />
        </div>

        {/* Visible Category Selector */}
        <EditableField
          value={filters.category ?? ''}
          onChange={handleCategoryChange}
          options={categoryOptions}
          placeholder="Select Category"
        />
      </div>
    </div>
  );
};

export default EditableComponent;